<template>
  <BCard>
    <div class="text-[#626262] text-3xl font-semibold mb-2">
      Campaign - Notification
    </div>
    <div class="flex flex-row justify-between items-center gap-[10px] mb-1">
      <div class="flex items-center gap-[10px]">
        <div class="d-flex">
          <BButton
            variant="outline-secondary"
            style="width: 40px;"
            class="d-flex justify-content-center align-items-center"
            :disabled="selected.length < 1"
            @click="deleteSelected()"
          >
            <BIcon
              icon="trash"
              aria-hidden="true"
            /></BButton>
          <b-badge
            v-if="selected.length >= 1"
            style="height: 20px;"
            class="badge-count"
            pill
            variant="danger"
          >
            {{ selected.length }}
          </b-badge>
        </div>
        <div class="text-center">

          <button
            class="btn-outline-primary rounded-lg mb-[-3px]"
            @click="filter = !filter"
          >
            <img
              class="w-11 p-[5px]"
              src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/filter-search.svg"
              alt="Komerce"
            >
          </button>
          <ul
            v-if="filter"
            class="d-block position-absolute bg-[#f9f9f9] z-10 text-black font-medium text-[12px]"
          >
            <div class="text-black text-start pl-2 py-1 text-[16px] border">
              Filter
            </div>

            <div>
              <button
                id="popoverNotif"
                variant="outline-primary"
                class="btn btn1 rounded-none mb-1 d-flex"
              >
                <span>Status</span>
              </button>
              <BPopover
                target="popoverNotif"
                triggers="focus"
                placement="left"
              >
                <BFormCheckboxGroup v-model="selectedStatusNotif">
                  <div
                    v-for="(item, index) in statusNotif"
                    :key="index"
                  >
                    <BFormCheckbox
                      :id="'filter_' + index"
                      :value="item.value"
                      class="mt-1"
                    >
                      <div class="text-black">
                        {{ item.text }}
                      </div>

                    </BFormCheckbox>
                  </div>
                </BFormCheckboxGroup>
              </BPopover>
            </div>
            <div>
              <button
                id="popoverTargetNotif"
                variant="outline-primary"
                class="btn btn1 rounded-none mb-1 d-flex"
              >
                <span>Target</span>
              </button>
              <b-popover
                :show.sync="isPopoverOpen"
                target="popoverTargetNotif"
                triggers="focus"
                placement="right"
                custom-class="w-100"
              >
                <div
                  v-for="(category, index) in optionTarget"
                  :key="index"
                  class="mb-2"
                >
                  <div
                    v-if="category.product_menu && category.product_menu.length"
                    v-b-toggle="`collapse-${category.label}`"
                    class="d-flex justify-between align-items-center"
                  >
                    <b-form-checkbox
                      v-model="category.checked"
                      @change="toggleCategory(category)"
                    >
                      <div class="d-flex align-items-center">
                        <img
                          :src="getCategoryLogo(category)"
                          height="24"
                          class="mr-2"
                          width="24px"
                        >
                        <span>{{ category.product_categories }}</span>
                      </div>
                    </b-form-checkbox>
                    <div class="ml-2">
                      <feather-icon
                        icon="ChevronDownIcon"
                      />
                    </div>
                  </div>

                  <b-form-checkbox
                    v-else
                    v-model="category.checked"
                    @change="toggleCategory(category)"
                  >
                    <div class="d-flex align-items-center">
                      <img
                        :src="getCategoryLogo(category)"
                        height="24"
                        class="mr-2"
                        width="24px"
                      >
                      <span>{{ category.product_categories }}</span>
                    </div>
                  </b-form-checkbox>

                  <BCollapse
                    v-if="category.product_menu && category.product_menu.length"
                    :id="`collapse-${category.label}`"
                  >
                    <div class="ml-4 mt-1">
                      <b-form-checkbox
                        v-for="(product, pIndex) in category.product_menu"
                        :key="pIndex"
                        v-model="product.checked"
                        @change="toggleProduct(category)"
                      >
                        <div class="d-flex align-items-center">
                          <img
                            :src="getProductLogo(product)"
                            height="20"
                            class="mr-2"
                            width="24px"
                          >
                          <span>{{ product.product_name }}</span>
                        </div>
                      </b-form-checkbox>
                    </div>
                  </BCollapse>
                </div>
              </b-popover>
            </div>
            <div class="hover:bg-[#FCD4BE] text-primary hover:text-white">
              <button
                class="btn btn2 font-semibold mb-1 d-flex"
                @click="handleResetFilter"
              >
                <span class="btn-txt">Reset Filter</span>
              </button>
            </div>
          </ul>
        </div>
        <div class="p-0 d-flex rounded-lg align-items-center border">
          <span class="k-search-normal-1 font-bold  align-middle mx-[5px] text-[20px]" />
          <BFormInput
            v-model="search"
            size="lg"
            placeholder="Cari Judul Campaign"
            class="border-0 w-100"
            maxlength="30"
            @input="searchData"
          />
        </div>
      </div>
      <BCol
        md="3"
        class="text-end"
      >
        <div class="ml-1" />
        <BButton
          variant="primary"
          class="rounded-lg"
          to="/notification/create"
        >
          <b-icon-plus /> Buat
        </BButton>
      </bcol>
    </div>
    <BOverlay
      variant="light"
      :show="isLoading"
      spinner-variant="primary"
      blur="0"
      opacity=".5"
      rounded="sm"
    >
      <BTable
        :fields="fields"
        :items="items"
        responsive
        tbody-tr-class="hover:bg-slate-100 transition-colors duration-300 cursor-pointer"
        @row-clicked="(item, _, e) => handleAction(item)"
      >
        <template #head(checkbox)>
          <div class="d-flex justify-content-center">
            <BCheckbox
              v-model="allSelected"
              :indeterminate="indeterminate"
              @change="selectAll"
            />
          </div>
        </template>
        <template #cell(checkbox)="data">
          <div class="d-flex justify-content-center">
            <BCheckbox
              v-model="selected"
              :value="data.item"
              @change="select()"
            />
          </div>
        </template>
        <template #cell(no)="data">
          {{ data.index + 1 }}
        </template>
        <template #cell(title)="data">
          <div>{{ data.item.title }}</div>
          <div class="text-[#828282] flex gap-5 items-center">
            <div>{{ DDMMMMYYYY(data.item.created_at) }}</div>
          </div>
        </template>
        <template #cell(target)="data">
          <div
            class="flex flex-wrap"
          >
            <div
              v-for="(service, idx) in data.item.target.product"
              :key="idx"
              class="d-flex align-items-center justify-content-center mr-[5px] h-[40px] w-[40px] border-2 products p-[3px]"
            >
              <img
                :src="service.product_logo"
                alt="Komerce"
                style="max-width: 25px;"
              >
            </div>
          </div>
        </template>
        <template #cell(status)="data">
          <span
            :class="classStatus(data.item.status)"
            class="font-medium"
          >
            {{ labelStatus(data.item.status) }}
          </span>
        </template>
        <template #cell(updated_at)="data">
          <div>{{ formatDate(data.item.updated_at) }}</div>
          <span class="text-muted">{{ formatTime(data.item.updated_at) }}</span>
        </template>
        <template #cell(action)="data">
          <span
            class="text-[#08A0F7] cursor-pointer underline"
            @click="handleAction(data.item)"
          >
            Detail
          </span>
        </template>
      </BTable>
    </BOverlay>
  </BCard>
</template>
<script>
import moment from 'moment'
import { newAxiosIns } from '@/libs/axios'
import { alertError, alertSuccess } from '@toast'
import { DDMMMMYYYY } from '@/libs/filterDate'
import { configColumn } from './config'

export default {
  data() {
    return {
      fields: configColumn,
      items: [],
      selected: [],
      allSelected: false,
      isLoading: false,
      status: 0,
      active: 0,
      alertError,
      alertSuccess,
      DDMMMMYYYY,
      search: '',
      filter: false,
      selectedStatusNotif: [],
      statusNotif: [
        { text: 'Aktif', value: 1 },
        { text: 'Draft', value: 2 },
        { text: 'Non Aktif', value: 3 },
      ],
      indeterminate: false,
      is_reload: true,
      optionTarget: [],
      selectedTarget: [],
      isPopoverOpen: false,
    }
  },
  watch: {
    selectedStatusNotif: 'getList',

    selected(newValue, oldValue) {
      if (newValue.length === 0) {
        this.indeterminate = false
      } else if (newValue.length === this.items.length) {
        this.indeterminate = false
      } else {
        this.indeterminate = true
      }
    },
  },
  created() {
    this.getList()
    this.getListProducts()
  },
  methods: {
    async getListProducts() {
      const url = 'sender/api/v2/campaign/get-info'
      await newAxiosIns.get(url)
        .then(res => {
          const { data } = res.data

          this.optionTarget = data.option_targets.map(cat => ({
            ...cat,
            checked: false,
            product_menu: cat.product_menu
              ? cat.product_menu.map(product => ({
                ...product,
                checked: false,
              }))
              : [],
          }))
        })
    },
    toggleCategory(category) {
      if (category.product_menu && category.product_menu.length) {
        category.product_menu.forEach(product => {
          // eslint-disable-next-line no-param-reassign
          product.checked = category.checked
        })
      }

      this.selectedTarget = this.optionTarget
        .map(cat => {
          let selectedProducts = []

          if (cat.product_menu && cat.product_menu.length) {
            selectedProducts = cat.product_menu
              .filter(p => p.checked)
              .map(p => ({
                name: p.product_name,
                logo: this.getProductLogo(p, true),
              }))
          } else if (cat.checked) {
            const whiteLogo = (cat.category_logo || []).find(l => l.type === 'white')
            selectedProducts = [
              {
                name: cat.product_categories,
                logo: whiteLogo ? whiteLogo.url : '',
              },
            ]
          }

          if (selectedProducts.length > 0) {
            return {
              category: cat.product_categories,
              products: selectedProducts,
            }
          }

          return null
        })
        .filter(Boolean)
      this.getList()
    },
    toggleProduct(category) {
      if (category.product_menu) {
        // eslint-disable-next-line no-param-reassign
        category.checked = category.product_menu.every(p => p.checked)
      }

      this.selectedTarget = this.optionTarget
        .map(cat => {
          let selectedProducts = []

          if (cat.product_menu && cat.product_menu.length) {
            selectedProducts = cat.product_menu
              .filter(p => p.checked)
              .map(p => ({
                name: p.product_name,
                logo: this.getProductLogo(p, true),
              }))
          }

          const isCategoryCheckedWithoutProducts = (!cat.product_menu || cat.product_menu.length === 0) && cat.checked

          if (selectedProducts.length > 0 || isCategoryCheckedWithoutProducts) {
            const categoryLogo = (cat.category_logo || []).find(l => l.type === 'white')
            return {
              category: cat.product_categories,
              products: selectedProducts.length > 0
                ? selectedProducts
                : [{
                  name: cat.product_categories,
                  logo: categoryLogo ? categoryLogo.url : '',
                }],
            }
          }

          return null
        })
        .filter(Boolean)
      this.getList()
    },
    removeProduct(productToRemove) {
      this.optionTarget.forEach(category => {
        if (category.product_menu && category.product_menu.length) {
          category.product_menu.forEach(product => {
            if (product.label === productToRemove.label) {
              // eslint-disable-next-line no-param-reassign
              product.checked = false
            }
          })
          // eslint-disable-next-line no-param-reassign
          category.checked = category.product_menu.some(p => p.checked)
        } else {
          // eslint-disable-next-line no-lonely-if
          if (category.label === productToRemove.label) {
            // eslint-disable-next-line no-param-reassign
            category.checked = false
          }
        }
      })
      this.selectedTarget = this.optionTarget
        .map(cat => {
          let selectedProducts = []

          if (cat.product_menu && cat.product_menu.length) {
            selectedProducts = cat.product_menu
              .filter(p => p.checked)
              .map(p => ({
                name: p.product_name,
                logo: this.getProductLogo(p, true),
              }))
          } else if (cat.checked) {
            const whiteLogo = (cat.category_logo || []).find(l => l.type === 'white')
            selectedProducts = [
              {
                name: cat.product_categories,
                logo: whiteLogo ? whiteLogo.url : '',
              },
            ]
          }

          if (selectedProducts.length > 0) {
            return {
              category: cat.product_categories,
              products: selectedProducts,
            }
          }

          return null
        })
        .filter(Boolean)
      this.getList()
    },
    updateSelectedTarget() {
      this.selectedTarget = this.optionTarget
        .map(cat => {
          const selectedProducts = (cat.product_menu || [])
            .filter(p => p.checked)
            .map(p => ({
              name: p.product_name,
              logo: this.getProductLogo(p, true),
            }))

          // eslint-disable-next-line no-mixed-operators
          if (selectedProducts.length > 0 || (!cat.product_menu || cat.product_menu.length === 0) && cat.checked) {
            return {
              category: cat.product_categories,
              products: selectedProducts,
            }
          }
          return null
        })
        .filter(Boolean)
      this.getList()
    },
    getProductLogo(product, isWhite = false) {
      const logo = (product.product_logo || []).find(l => l.type === (isWhite ? 'white' : 'default'))
      return logo ? logo.url : ''
    },
    getCategoryLogo(category) {
      const logo = category.category_logo.find(l => l.type === 'default')
        || category.category_logo[0]
      return logo.url
    },
    async getList() {
      this.isLoading = true
      const selectedTargetStructure = this.optionTarget
        .flatMap(cat => {
          if (!cat.product_menu || !cat.product_menu.length) {
            return cat.checked ? [cat.label] : []
          }

          return cat.product_menu
            .filter(p => p.checked)
            .map(p => p.label)
        })
        .filter(Boolean)
        .join(',')

      const params = {
        search: this.search,
        status: this.selectedStatusNotif.join(','),
        is_quick_reload: this.is_reload,
        target: selectedTargetStructure,
      }

      const url = '/sender/api/v2/campaign/notification-bar'

      try {
        const res = await newAxiosIns.get(url, { params })
        const { data } = res.data
        this.items = data
      } catch (error) {
        this.alertError('Gagal load data campaign')
      } finally {
        this.isLoading = false
      }
    },
    searchData: _.debounce(function search() {
      this.getList()
    }, 1000),
    formatDate(date) {
      const validDate = moment(date)
      if (validDate.isValid()) {
        const monthName = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
        const day = moment(date).format('DD')
        const month = moment(date).format('M')
        const year = moment(date).format('YYYY')
        return `${day} ${monthName[month - 1]} ${year}`
      }
      return ''
    },
    formatTime(date) {
      const validDate = moment(date)
      if (validDate.isValid()) {
        const time = moment(date).format('HH:mm')
        return time
      }
      return ''
    },
    selectAll(checked) {
      // eslint-disable-next-line no-plusplus
      this.selected = checked ? this.items.slice() : []
    },
    select() {
      this.allSelected = false
    },
    deleteSelected() {
      this.isLoading = true
      const data = {
        ids: this.selected.map(item => item.id),
      }
      this.$swal({
        title: '<span class="font-medium text-[16px]">Kamu yakin ingin menghapus notifikasi ini?</span>',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/warning.svg'),
        confirmButtonText: 'Hapus',
        confirmButtonClass: 'btn btn-primary rounded-lg',
        showCancelButton: true,
        cancelButtonText: 'Batal',
        cancelButtonClass: 'btn btn-outline-primary bg-white text-primary rounded-lg',
      }).then(res => {
        const { isConfirmed } = res
        if (isConfirmed) {
          const url = '/sender/api/v2/campaign/notification-bar'
          newAxiosIns.delete(url, { data })
            .then(() => {
              this.isLoading = false
              this.alertSuccess(`Berhasil hapus ${this.selected.length} data Notifikasi`)
              this.getList()
              this.selected = []
            })
            .catch(() => {
              this.isLoading = false
              this.alertError('Gagal hapus data')
            })
        } else {
          this.isLoading = false
          this.$swal.close()
        }
      })
    },
    click() {
      this.status = this.status === 1 ? 0 : 1
    },
    classCampaignType(type) {
      if (type === 1) {
        return 'text-[#FBBC05]'
      }
      return 'text-[#4285F4]'
    },
    labelStatus(status) {
      if (status === 0) {
        return 'Tidak Aktif'
      }
      if (status === 1) {
        return 'Aktif'
      }
      if (status === 2) {
        return 'Draft'
      }
      return 'Selesai'
    },
    classStatus(status) {
      if (status === 0) {
        return 'text-[#E31A1A]'
      }
      if (status === 1) {
        return 'text-[#34A770]'
      }
      if (status === 2) {
        return 'text-[#828282]'
      }
      return 'text-[#34A770]'
    },
    handleAction({ id, type }) {
      return this.$router.push(`/notification/create/${id}?type=${type}`)
    },
    async handleResetFilter() {
      this.selectedStatusNotif = []
      this.selectedTarget = []
      this.optionTarget.forEach(category => {
        // eslint-disable-next-line no-param-reassign
        category.checked = false
        if (category.product_menu && category.product_menu.length) {
          category.product_menu.forEach(product => {
            // eslint-disable-next-line no-param-reassign
            product.checked = false
          })
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import './notification';

.btn1:hover {
  background-color: #F95031;
  color: white;
  border-radius: 0;
}

.btn-txt {
  color: #F95031;
  font-weight: 600;
}
.badge-count {
    position: absolute;
    margin-left: 30px;
    margin-top: -10px;
}
.products {
  border-radius: 20px;
  border-color: #C2C2C2 !important;
}

</style>
